"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRateHostService = void 0;
const types_1 = require("@shapeshiftoss/types");
const dayjs_1 = __importDefault(require("dayjs"));
const config_1 = require("../config");
const bignumber_1 = require("../utils/bignumber");
const rateLimiters_1 = require("../utils/rateLimiters");
const axios = (0, rateLimiters_1.rateLimitedAxios)(config_1.RATE_LIMIT_THRESHOLDS_PER_MINUTE.DEFAULT);
const baseCurrency = 'USD';
class ExchangeRateHostService {
    constructor() {
        this.baseUrl = 'https://api.exchangerate.host';
        this.findByFiatSymbol = async ({ symbol }) => {
            try {
                const { data } = await axios.get(`${this.baseUrl}/latest?base=${baseCurrency}&symbols=${symbol}`);
                // we only need the price key in the `web`
                return {
                    price: data.rates[symbol].toString(),
                    marketCap: '0',
                    changePercent24Hr: 0,
                    volume: '0'
                };
            }
            catch (e) {
                console.warn(e);
                throw new Error('FiatMarketService(findByFiatSymbol): error fetching market data');
            }
        };
        this.findPriceHistoryByFiatSymbol = async ({ symbol, timeframe }) => {
            const end = (0, dayjs_1.default)().startOf('day');
            let start;
            switch (timeframe) {
                case types_1.HistoryTimeframe.HOUR:
                    start = end.subtract(1, 'hour');
                    break;
                case types_1.HistoryTimeframe.DAY:
                    start = end.subtract(1, 'day');
                    break;
                case types_1.HistoryTimeframe.WEEK:
                    start = end.subtract(1, 'week');
                    break;
                case types_1.HistoryTimeframe.MONTH:
                    start = end.subtract(1, 'month');
                    break;
                case types_1.HistoryTimeframe.YEAR:
                    start = end.subtract(1, 'year');
                    break;
                case types_1.HistoryTimeframe.ALL:
                    start = end.subtract(20, 'years');
                    break;
                default:
                    start = end;
            }
            try {
                const from = start.startOf('day').format('YYYY-MM-DD');
                const to = end.startOf('day').format('YYYY-MM-DD');
                const url = `${this.baseUrl}/timeseries?base=${baseCurrency}&symbols=${symbol}&start_date=${from}&end_date=${to}`;
                const { data } = await axios.get(url);
                return Object.entries(data.rates).reduce((acc, [formattedDate, ratesObject]) => {
                    const date = (0, dayjs_1.default)(formattedDate, 'YYYY-MM-DD').startOf('day').valueOf();
                    const price = (0, bignumber_1.bnOrZero)(ratesObject[symbol]).toNumber();
                    acc.push({ date, price });
                    return acc;
                }, []);
            }
            catch (e) {
                console.warn(e);
                throw new Error('ExchangeRateHost(findPriceHistoryByFiatSymbol): error fetching price history');
            }
        };
    }
}
exports.ExchangeRateHostService = ExchangeRateHostService;
